import type { Meta, StoryObj } from '@storybook/angular';
import { moduleMetadata } from '@storybook/angular';
import { expect, within } from 'storybook/test';
import { ProductDataSectionComponent } from '../../app/content/modules/page/components/product/components/product-data-section/product-data-section.component';
import { ProductDescriptionSectionComponent } from '../../app/content/modules/page/components/product/components/product-description-section/product-description-section.component';
import { withCommonDecorators } from '../_utils/story-helpers';
import { createDamilanoBarberaProduct } from '../_mocks/wine-product.mock';

const meta: Meta = {
  title: 'Compositions/Product Detail - Info Section',
  tags: ['autodocs'],
  decorators: [
    ...withCommonDecorators(),
    moduleMetadata({
      imports: [ProductDataSectionComponent, ProductDescriptionSectionComponent],
    }),
  ],
  parameters: {
    docs: {
      description: {
        component: 'Composition of the product detail page info section — matching the live PDP layout with description section first, then wine data below.',
      },
    },
  },
};
export default meta;
type Story = StoryObj;

const product = createDamilanoBarberaProduct();

export const FullInfoSection: Story = {
  render: () => ({
    template: `
      <article class="container" style="max-width: 900px; background-color: #fff;">
        <app-product-description-section [product]="product"></app-product-description-section>
        <app-product-data-section [product]="product"></app-product-data-section>
      </article>
    `,
    props: { product },
  }),
  play: async ({ canvasElement }) => {
    const canvas = within(canvasElement);
    await expect(canvas.getByText(/damilano barbera/i)).toBeInTheDocument();
    await expect(canvasElement.querySelector('app-product-data-section')).toBeTruthy();
  },
};

export const DescriptionSectionOnly: Story = {
  render: () => ({
    template: `
      <div class="container" style="max-width: 900px; background-color: #fff;">
        <app-product-description-section [product]="product"></app-product-description-section>
      </div>
    `,
    props: { product },
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-description-section')).toBeTruthy();
  },
};

export const DataSectionOnly: Story = {
  render: () => ({
    template: `
      <div class="container" style="max-width: 900px; background-color: #fff;">
        <app-product-data-section [product]="product"></app-product-data-section>
      </div>
    `,
    props: { product },
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-product-data-section')).toBeTruthy();
  },
};
